// Subset of PAYMENT_QUERY_PARAMS in ./helpers for the PayPal express code that runs in the header on every
// page; importing ./helpers there would pull @adyen/adyen-web into every page.
export const PAYPAL_EXPRESS_QUERY_PARAMS = {
  additionalAction: 'additional-action-status',
  errorCode: 'error-code',
  orderId: 'order-id',
  transactionId: 'transaction-id',
} as const;
